export const registerErrorInformation: { [id: string]: string } = {
  requiredPasswordForNonHcpUsers: "Password is required for non-hcp users",
  userAlreadyExist: "User already exists",
  "Takeda error | getUserConsent": "Error in registering user consent",
  crmCountryNotMatched: "CRM country not matched",
};
